
function markUp( text ){
  let textMark  = ''
  let counter = 0
  let startMark = false

  for (const key in text) {
      if (Object.hasOwnProperty.call(text, key)) {
          const item = text[key];
          let isChar = false
          if(item.search(/[กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะเแโใไๅๆ]/g) === 0){
              counter++
              isChar = true
          }
          if(counter === 4){
              startMark = true
          }

          if(startMark){
              if(isChar){
                  textMark += 'x'
              }
          }else{
              textMark += item
          }
      }
  }
  return textMark  
}

export { markUp }